<template>
    <div id="teethListContainer" class="teeth-ctrls panel-group teeth-list-ctrl">
        <div id="teethListPanel" ref="teethListPanel" class="collapse list-group teeth-panel ">
            <div class="teeth-settings">
                <li v-if="!isNoTeeth && !isViewMode" class="list-group-item setting-item active">Settings</li>
                <li v-if="!isNoTeeth && !isViewMode" class="list-group-item setting-item">
                    <!-- <input type="range" class="form-control-range"> -->
                    <button type="button" class="btn btn-secondary btn-sm btn-block setting-btn"
                        v-on:click="addTooth">Add Tooth</button>
                </li>
                <li v-if="!isNoTeeth" class="list-group-item setting-item active">Visibility</li>
                <li v-if="!isNoTeeth" class="list-group-item setting-item visibiltiy-group">
                    <!-- <div class="mb-2 mt-1 setting-group"> -->
                    <label v-for="option in filteredVisibilities" class="setting-ctrl">
                        <span class="check-label">{{ option.text }}</span>
                        <input type="checkbox" class="check-input" v-model="option.value"
                            @change="visibilityChanged(option.key, option.value)">
                    </label>

                    <label v-if="hasClosedBones" class="setting-ctrl">
                        <span class="check-label">Color Teeth Roots</span>
                        <input type="checkbox" class="check-input" v-model="showTeethRoots"
                            @change="showTeethRootsChanged()">
                    </label>
                    <div v-if="isStitched" class="source-type-group">
                        <img v-show="isSwitchStitching" class="switch-stitching-img"
                            src="images/dark-blue-spinner.gif" />
                        <label class="source-type-label">
                            <input id="rbCbctSourceType" class="source-type-rb" type="radio" name="sourceType"
                                value="cbct" @click="sourceTypeChanged('cbct')" v-model="localSourceType">
                            <span class="source-type-span">CBCT</span>
                        </label>
                        <label class="source-type-label">
                            <input id="rbStitchedSourceType" class="source-type-rb" type="radio" name="sourceType"
                                value="stitched" @click="sourceTypeChanged('stitched')" v-model="localSourceType">
                            <span class="source-type-span">Stitched</span>
                        </label>
                    </div>

                    <!-- </div> -->
                </li>
                <li v-if="!isNoTeeth" class="list-group-item setting-item active">Teeth Naming</li>
                <li v-if="!isNoTeeth && !isViewMode" class="list-group-item setting-item">
                    <!-- <input type="range" class="form-control-range"> -->
                    <select v-model="teethNaming" class="form-control form-control-sm" @change="teethNamingChanged()">
                        <option v-for="option in teethNamings" v-bind:value="option.value">
                            {{ option.text }}
                        </option>
                    </select>
                </li>

                <li class="list-group-item setting-item active">Elements</li>
            </div>
            <div id="teethList" class="teeth-list" ref="teethList"></div>
            <div class="teeth-list-bottom">
                <button type="button" class="btn btn-primary btn-sm btn-block cancel-btn" v-on:click="close">Close
                </button>
            </div>
        </div>
    </div>
</template>

<script>

import swal from "sweetalert";

import { showToothAddDialog } from "@/components/tooth/add/ToothAddMode";
import { ISO, UNS, ALPHANUM, updateTeethNaming } from "@/components/tooth/teethNaming.js";
import { switchStitching } from "@/components/appStart/stitching";

const ONLY_TEETH = "OnlyTeeth";

export default {
    name: "TeethListPanel",
    props: {
        allItems: {
            type: Array,
            required: false
        },
        isOnlyTeeth: {
            type: Boolean,
            required: true
        },
        isNoTeeth: {
            type: Boolean,
            required: true
        },
        isViewMode: {
            type: Boolean,
            required: true
        },
        isStitched: {
            type: Boolean,
            required: true
        },
        hasClosedBones: {
            type: Boolean,
            required: true
        },
        isStitching: {
            type: Boolean,
            required: true
        },
        isDicomOpen: {
            type: Boolean,
            required: true
        },
        viewSourceType: {
            type: String,
            required: true
        }
    },
    watch: {
        "viewSourceType": {
            handler(newVal, oldVal) {
                console.log("watch viewSourceType", newVal);
                this.localSourceType = newVal;
            }
        },
    },
    data() {
        return {
            showTeethRoots: false,
            visibilities: [
                { text: "Max Teeth", key: "Maxilla", value: true },
                { text: "Mand Teeth", key: "Mandible", value: true },
                { text: "View Only Teeth", key: ONLY_TEETH, value: false },
                // { text: "Maxilla", key: "maxilla", value: false },
                // { text: "Mandible", key: "mandible", value: false },
                // { text: "Airway", key: "airway", value: false }
            ],
            teethNaming: 'iso',
            teethNamings: [
                { text: "ISO 3950", value: ISO },
                { text: "UNS", value: UNS },
                { text: "Alphanum.", value: ALPHANUM }
            ],
            localSourceType: 'cbct',
            isSwitchStitching: false,
            isFirstSwitch: true
        }
    },
    methods: {
        showTeethRootsChanged: function () {
            console.log("showTeethRootsChanged", this.showTeethRoots);
            vueApp.showTeethRoots = this.showTeethRoots;
            vueApp.allTeeth.forEach((model) => {
                let mesh = viewer.get_model_mesh(model.id);
                if (mesh && mesh.rootCrownMaterials && mesh.originalMaterial) {
                    mesh.material = vueApp.showTeethRoots ? mesh.rootCrownMaterials : mesh.originalMaterial;
                }
            });
        },
        sourceTypeChanged: function (sourceType) {
            // var sourceType = this.localSourceType; // $('input[name="sourceType"]:checked').val();
            console.log("sourceTypeChanged", new Date(), sourceType);
            if (vueApp.viewSourceType == sourceType) {
                return;
            }
            // this.localSourceType = vueApp.viewSourceType = sourceType;
            // switchStitching(sourceType);
            if (vueApp.isStitching) {
                // if (this.localSourceType != 'cbct') {
                console.log('localSourceType', this.localSourceType);
                this.localSourceType = 'cbct';
                $("#rbCbctSourceType").prop("checked", true);
                $("#rbStitchedSourceType").prop("checked", false);
                // }
                swal({
                    text: "Cannot switch to stitched view while post processing.",
                });
            } else {
                vueApp.viewSourceType = vueApp.savedData.viewSourceType = sourceType;
                this.isSwitchStitching = true; // this.isFirstSwitch;
                console.log("isSwitchStitching", new Date(), sourceType);
                if (this.isFirstSwitch) {
                    setTimeout(() => {
                        // vueApp.saveData();
                        switchStitching(sourceType);
                        this.isSwitchStitching = false;
                    }, 500);
                    this.isFirstSwitch = false;
                } else {
                    // vueApp.saveData();
                    switchStitching(sourceType);
                    this.isSwitchStitching = false;
                }
            }
        },
        teethNamingChanged: function () {
            updateTeethNaming(this.teethNaming);
        },
        addTooth: function () {
            showToothAddDialog();
        },
        close: function () {
            console.log("close teethListPanel");
            // $(`#teethListPanel`).css({
            //     display: "none",
            // });
            $(`#teethListPanel`).removeClass("show");
        },
        visibilityChanged: function (key, value) {
            let arr = [];
            if (key == ONLY_TEETH) {
                vueApp.bones.concat(vueApp.nerves).concat(vueApp.gingivae)
                    .concat(vueApp.airways).forEach(function (item) {
                        item.isVisible = !value;
                        itemVisibilityChanged(item, item.color, item.opacity)
                    });

            }
            else {
                this.visibilities.forEach(option => {
                    let dentitionName = option.key;
                    if (option.value) {
                        arr.push(dentitionName);
                    }
                    var dentation = vueApp.dentations.find(x => x.name === dentitionName);
                    if (dentation) {
                        dentation.isVisible = option.value;
                        vueApp.allTeeth.forEach(function (item) {
                            if (item.dentition == dentitionName && (!item.isHidden || !dentation.isVisible)) { //(dentationTeeth.includes(item)) {
                                item.isVisible = dentation.isVisible;
                                itemVisibilityChanged(item, item.color, vueApp.teethOpacity)
                            }
                        });
                    }
                });
            }
            vueApp.$emit('visibilityChanged', { name: key, isVisible: value });
            console.log("visibilityChanged", key, value, arr);
        }
    },
    mounted() {
        // console.log("TeethListPanel mounted", this.allItems);
        // this.app.assignPanelId = `${this.app.orientation}_assign_panel`;
        // this.$refs.teethListPanel.setAttribute("id", this.app.assignPanelId);
    },
    computed: {
        filteredVisibilities: function () {
            return this.isOnlyTeeth ? this.visibilities.filter(v => v.key != ONLY_TEETH) : this.visibilities;
        }
    }
}

</script>

<style scoped>
.visibiltiy-group {
    color: white;
    background-color: #77a7fd;
}

.source-type-group {
    vertical-align: middle;
    min-height: 25px;
    height: 25px;
    margin-top: 5px;
    text-align: right;
}

.source-type-label {
    display: inline-block;
    margin-left: 8px;
    margin-top: 2px;
    /* height: 25px; */
}

.source-type-span {
    vertical-align: middle;
}

.source-type-rb {
    margin-right: 3px;
    vertical-align: middle;
}

.switch-stitching-img {
    display: inline;
    width: 25px;
    height: 25px;
}

#teethListContainer {
    display: none;
    z-index: 1000;
}

.btn {
    font-size: small;
}

.setting-group {
    text-align: right;
    border: 1px solid #ced4da;
    align-items: end;
    border-radius: 0.2rem;
    padding-right: 5px;
}

.setting-ctrl {
    text-align: right;
    display: block;
    white-space: nowrap;
    margin: 0;
}

.check-label {
    margin-right: 0.5rem;
    vertical-align: middle;
}

.check-input {
    /* margin-top: 20px; */
    vertical-align: middle;
}

.teeth-ctrls {
    position: absolute;
    top: 10px;
    right: 45px;
    z-index: 9;
    text-align: right;
    height: calc(100vh - 45px);
    width: 0;
    font-family: Montserrat, sans-serif;
    font-size: small;
    background-color: red;
    overflow: visible;
}

.teeth-panel {
    /* border-radius: 0.25rem;  */
    position: absolute;
    width: 200px;
    right: -40px;
    top: 30px;
    max-height: calc(100% - 40px);
    overflow-y: scroll;
    border-top-right-radius: 0.25rem;
    border-top-left-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
    /* border: solid 1px white; */
}

.teeth-settings {
    width: 100%;
    background: #77a7fd;
    border-top-right-radius: 0.25rem;
    border-top-left-radius: 0.25rem;
}

.setting-item {
    text-align: center;
    padding: .3rem .4rem;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
}

.setting-btn {
    margin: 2px 0;
    padding: 0;
}

.teeth-list {
    background: white;
    /* #77a7fd; */
    overflow-y: scroll;
    /* max-height: calc(100% - 120px); */
    width: 100%;
    /* calc(100% - 1px); */
    /* margin-left: 1px;
    margin-top: 1px; */
}

.teeth-list-bottom {
    padding-bottom: 8px;
    background-color: white;
    width: 100%;
    border-bottom-right-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
}

.apply-btn {
    margin: 0px 5px 0 5px;
    width: calc(100% - 10px);
}

.cancel-btn {
    margin: 8px 5px 0px 5px;
    width: calc(100% - 10px);
}

::-webkit-scrollbar {
    width: 5px;
}

::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px transparent;
    border-radius: 10px;
}

::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
    background: #007bff;
}
</style>